import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './Context/authContext';
import { LoadingProvider } from './Context/loadingContext';
import Loader from './Components/Loader';
import Toaster from './Components/Toaster';
import MainLayout from './Container/MainLayout';
import AnalyticsTracker from './Components/AnalyticsTracker';
import './App.css';

function App() {
  return (
    <Router>
      <AnalyticsTracker />
      <AuthProvider>
        <LoadingProvider>
          <div className="App min-h-screen bg-slate-50 text-slate-900">
            <MainLayout />
            <Loader />
            <Toaster />
          </div>
        </LoadingProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
